const keyMap = new WeakMap();
let lastId = 0;
/**
 * Returns the same string key for the given value. Keys are guaranteed to
 * be unique to each-other (but not globally). Appropriate for use with React
 * key props.
 */

export default function identityKey(obj: unknown): string {
  if (typeof obj === 'object' && obj !== null) {
    if (!keyMap.has(obj)) {
      keyMap.set(obj, lastId++);
    }

    return `ref:${String(keyMap.get(obj))}`;
  }

  // value types can just be used as-is
  return `val:${typeof obj}:${String(obj)}`;
}
